module.exports = __webpack_public_path__ + "static/media/landing-page-img.ce01b032.svg";